var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-emo-well"},[_c('img',{attrs:{"src":_vm.wellImgUrl,"alt":"xxxxxxxxxxxx"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"c-fs-14",style:({color: _vm.returnTextClasses})},[_c('b',[_vm._v(_vm._s(_vm.wellMsg))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c026ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wells/EmoWellComp.vue
// module id = null
// module chunks = 